import { Dispatch, SetStateAction } from 'react';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { Button } from '../../../components/common/Button/Button';
import { Box, Flexed } from '../../../styles/GlobalComponents';

import { Icon, IconFlipme } from '../../../styles/Icons';
import { RedeemFlipmeCardsStepsEnum } from './types';
import { P1, P2 } from '../../../styles/FontStyles';

import Spinner from '../../../components/common/Spinner';
import {
  redeemFlipmeCard,
  redeemFlipmeCardInRank
} from '../../FlipMeWallet/FlipMeWallet.actions';

interface Step1Props {
  setRedeemFlipmeCardsStep: Dispatch<
    SetStateAction<RedeemFlipmeCardsStepsEnum>
  >;
  setRedeemCardsModal: Dispatch<SetStateAction<boolean>>;
  packageId: number | null | undefined;
}

export const Step1 = ({
  setRedeemFlipmeCardsStep,
  setRedeemCardsModal,
  packageId
}: Step1Props) => {
  const dispatch = useAppDispatch();
  const { flipmeWallet, loadingRedeemFlipmeCards } = useAppSelector(
    (state) => state.wallets
  );

  return (
    <>
      {loadingRedeemFlipmeCards ? (
        <Spinner />
      ) : (
        <>
          {' '}
          <Flexed column center>
            <Icon>
              <IconFlipme />
            </Icon>

            <P2 bold mt='30' mb='30' center>
              Activating this card will create the card in FlipMe application.
              Card activation is possible only one time.
            </P2>
          </Flexed>
          <Flexed>
            <Button
              mt='20'
              mr='10'
              negative
              onClick={() => setRedeemCardsModal(false)}>
              Cancel
            </Button>
            <Button
              mt='20'
              ml='10'
              onClick={() => {
                packageId
                  ? dispatch(
                      redeemFlipmeCard({
                        userPackageId: packageId,
                        walletAddress: flipmeWallet,
                        setRedeemFlipmeCardsStep
                      })
                    )
                  : dispatch(
                      redeemFlipmeCardInRank({ setRedeemFlipmeCardsStep })
                    );
              }}>
              Activate
            </Button>
          </Flexed>
        </>
      )}
    </>
  );
};
